import React from 'react';

const Footer = () => (
    <div style={{
        width: '100%',
        padding: '20px',
        textAlign: 'center',
        background: 'transparent',
        marginTop: 'auto',
        color: '#FF0095',
        textShadow: '0 0 10px #FF0095, 0 0 20px #FF0095',
        zIndex: 100,
        position: 'relative'
    }}>
        <p style={{ margin: 0, fontSize: '0.9rem', letterSpacing: '2px', fontFamily: 'Orbitron' }}>
            © SAMAARAMBH 10.0
        </p>
    </div>
);

export default Footer;
